const bazarCn = {
  common: {
    brandLabel: '品牌',
    storeLabel: '商店',
    unitCount: '',
  },
  search: {
    placeholders: [
      '输入产品名称...',
      '输入品牌名称...',
      '输入商店名称...',
      '输入类别名称...'
    ]
  },
  sidebar: {
    categoriesTitle: '类别',
    storesTitle: '商店',
  },
  store: {
    serviceAreaLabel: '服务区域',
    nationwide: '全国',
    productCount: '产品',
    productsOfSuffix: '产品',
    description: '以下是此商店的所有可用产品。您可以按类别筛选。',
  },
  buttons: {
    details: '详情',
    addToCart: '添加到购物车',
    clearFilters: '清除筛选',
    close: '关闭',
  },
  empty: {
    title: '未找到产品',
    subtitle: '请调整您的筛选条件或搜索',
  },
};

export default bazarCn;
